<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>
        <a [routerLink]="['/agenda']">Agenda</a>
    </li>
    <li>
        <span>{{PageTitle}}</span>
    </li>
</ul>
<div class="loader" align="center" *ngIf="loading">
    <div>
        <!-- -->
    </div>
</div>
<section class="card" [ngStyle]="{'opacity':loading === true ? 0.5 : 1}">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>{{PageTitle}}</strong>
        </span>
        <span style="float: right">
            <button class="btn btn-sm btn-primary" type="button" data-toggle="modal" data-target="#categoryDialog"
                [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}"
                (click)="showAddPopUp()">
                <i class="fa fa-plus"></i>&nbsp;Add New Category</button>
            <button type="button" class="btn btn-sm btn-default" (click)="back()">
                <i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>

        </span>

    </div>
    <div class="card-block">
        <div class="row">

            <div class="col-md-12">
                <form [formGroup]="agendaAddForm" class="well">
                    <div class="row">
                        <div class="col-md-2">
                            <label class=" col-form-label" for="l0">Agenda Title
                                <span style="color: red;">*</span>
                            </label>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">

                                <textarea class="form-control" id="15"
                                    [formControl]="agendaAddForm.controls['agendaTitle']" autocomplete="off"
                                    id="agendaTitle"></textarea>

                                <div *ngIf="(agendaAddForm.controls['agendaTitle'].hasError('required') && agendaAddForm.controls['agendaTitle'].touched)"
                                    class="form-control-error-custom">
                                    Agenda Title type is required
                                </div>
                                <div *ngIf="!agendaAddForm.controls['agendaTitle'].hasError('required')  && agendaAddForm.controls['agendaTitle'].hasError('whitespace') && agendaAddForm.controls['agendaTitle'].touched"
                                    class="form-control-error-custom">
                                    Agenda Title is invalid
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-6"></div> -->
                        <!-- <div class="col-md-2">
                            <label class=" col-form-label" for="l0">Agenda Number Prefix

                            </label>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <input type="text" class="form-control" [formControl]="agendaAddForm.controls['agendaNumberPrefix']">
                            </div>
                        </div> -->

                        <div class="col-md-2">
                            <label class="col-form-label" for="l0">Select Meeting Type
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <select *ngIf="!disableOnEdit" class="form-control"
                                    [formControl]="agendaAddForm.controls['meetingType']"
                                    (ngModelChange)="getMeetingFromType($event)">
                                    <option value=null [selected]="true">Select</option>
                                    <option *ngFor="let meetingTypeList of meetingTypes" [value]="meetingTypeList._id">
                                        {{meetingTypeList.MeetingType}}</option>
                                </select>
                                <div *ngIf="agendaAddForm.controls['meetingType'].hasError('required') && agendaAddForm.controls['meetingType'].touched"
                                    class="form-control-error-custom">Meeting type is required
                                </div>
                                <!-- <select *ngIf="disableOnEdit" class="form-control"
                                    [formControl]="agendaAddForm.controls['meetingType']" disabled>
                                    <option *ngFor="let meetingTypeList of meetingTypes" [value]="meetingTypeList._id">
                                        {{meetingTypeList.MeetingType}}</option>
                                </select> -->
                                <input id="meetingTypeName" *ngIf="disableOnEdit" type="text" class="form-control">
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label class=" col-form-label" for="l0">Agenda Number
                                <span style="color: red;">*</span>
                            </label>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <input type="text" class="form-control"
                                    [formControl]="agendaAddForm.controls['agendaNumber']">
                                <div *ngIf="(agendaAddForm.controls['agendaNumber'].hasError('required') && agendaAddForm.controls['agendaNumber'].touched)"
                                    class="form-control-error-custom">
                                    Agenda Number is required
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label class="form-control-label">Library Agenda</label>
                            <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">

                                <div class="md-radio" *ngIf="!disableOnEdit">
                                    <input type="radio" id="Yes"
                                        [formControl]="agendaAddForm.controls['IscategorySelected']"
                                        style="position:absolute" name="Category" value='Yes'
                                        (click)="CheckCategory('Yes')" class="form-check-input">
                                    <label for="Yes" class="form-check-label">Yes</label>
                                    <input type="radio" id="No"
                                        [formControl]="agendaAddForm.controls['IscategorySelected']"
                                        style="position:absolute" name="Category" value='No'
                                        (click)="CheckCategory('No')" class="form-check-input">
                                    <label for="No" class="form-check-label">No</label>
                                </div>
                                <div class="md-radio" *ngIf="disableOnEdit">
                                    <input disabled type="radio" id="Yes"
                                        [formControl]="agendaAddForm.controls['IscategorySelected']"
                                        style="position:absolute" value='Yes' class="form-check-input">
                                    <label for="Yes" class="form-check-label">Yes</label>
                                    <input disabled type="radio" id="No"
                                        [formControl]="agendaAddForm.controls['IscategorySelected']"
                                        style="position:absolute" value='No' class="form-check-input">
                                    <label for="No" class="form-check-label">No</label>
                                </div>

                                <div *ngIf="agendaAddForm.controls['IscategorySelected'].hasError('required') && agendaAddForm.controls['IscategorySelected'].touched"
                                    class="form-control-error-custom">Category is required
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2" *ngIf="isCategoryNoBoolean">
                            <label class="form-control-label">Assign to Meeting</label>
                            <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-4" *ngIf="isCategoryNoBoolean">
                            <div class="form-group">
                                <div class="md-radio">

                                    <input type="radio" id="MYes"
                                        [formControl]="agendaAddForm.controls['IsMeetingAssigned']"
                                        style="position:absolute" name="assignToMeeting" value='Yes'
                                        (click)="CheckAssignMeeting('Yes')" class="form-check-input">
                                    <label for="MYes" class="form-check-label">Yes</label>

                                    <input type="radio" id="MNo"
                                        [formControl]="agendaAddForm.controls['IsMeetingAssigned']"
                                        style="position:absolute" name="assignToMeeting" value='No'
                                        (click)="CheckAssignMeeting('No')" class="form-check-input">
                                    <label for="MNo" class="form-check-label">No</label>

                                </div>
                                <div *ngIf="agendaAddForm.controls['IsMeetingAssigned'].hasError('required') && agendaAddForm.controls['IsMeetingAssigned'].touched"
                                    class="form-control-error-custom">Assign to Meeting is required
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2" *ngIf="catBoolean">
                            <label class="col-form-label" for="l0">Category Name</label>
                        </div>
                        <div class="col-md-4" *ngIf="catBoolean">
                            <div class="form-group">
                                <select *ngIf="!disableOnEdit" class="form-control"
                                    [formControl]="agendaAddForm.controls['selectCategory']">
                                    <option [selected]="true" value=null>Select</option>
                                    <option *ngFor="let category of categories" [value]="category._id">
                                        {{category.CategoryName}}</option>
                                </select>

                                <div *ngIf="booleanCategoryValidate" class="form-control-error-custom">Category is
                                    required
                                </div>
                                <select *ngIf="disableOnEdit" disabled class="form-control disableOnEdit"
                                    [formControl]="agendaAddForm.controls['selectCategory']">
                                    <option *ngFor="let category of categories" [value]="category._id">
                                        {{category.CategoryName}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <label class="col-form-label" for="l0">Index Grouping</label>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group" *ngIf="indexGroupingList">
                                <select class="form-control" [formControl]="agendaAddForm.controls['indexGrouping_id']"
                                    (change)="changeGroup($event)">
                                    <option [selected]="true" value=null>Select</option>
                                    <option *ngFor="let group of indexGroupingList" [value]="group._id">
                                        {{group.GroupName}}</option>
                                </select>

                            </div>

                        </div>
                        <div class="col-md-2">
                            <span style="float: left">
                                <button class="btn btn-sm btn-primary" type="button" data-toggle="modal"
                                    data-target="#indexGrouping" (click)="showAddPopUpIndexGroup()"
                                    [appHasPermission]="{'Url': '/agendaGroup/edit?goveva=true&email=', 'method':'put', 'menu': 'AgendaGroup'}">
                                    <i class="fa fa-plus"></i>&nbsp;Add New</button>
                            </span>
                        </div>

                        <!-- department -->
                        <div class="col-md-2">
                            <label class="col-form-label" for="l0">Department</label>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <select class="form-control" [formControl]="agendaAddForm.controls['department']">
                                    <option [selected]="true" value=null>Select</option>
                                    <option *ngFor="let department of responseDepartment" [value]="department._id">
                                        {{department.departmentName}}</option>
                                </select>

                            </div>

                        </div>

                        <!-- agenda type -->
                        <!-- <div class="col-md-2">
                            <label class="col-form-label" for="l0">Agenda Type</label>
                        </div> -->
                        <!-- <div class="col-md-4">
                            <div class="form-group" > -->
                        <!-- <select class="form-control" [formControl]="agendaAddForm.controls['agendaType']" >
                                    <option [selected]="true" value=null>Select</option>
                                    <option *ngFor="let option of agendaTypeOption" [value]="option._id">
                                        {{option.name}}</option>
                                </select> -->
                        <!-- <datalist id="agendatypedata" *ngIf="agendaNameFieldTouched" >
                                    <option *ngFor="let option of agendaTypeOption">{{option}}</option>
                                 </datalist>
                                 <input type="text" (keyup)="getAgendaType()" list="agendatypedata" size="10" class="form-control" (focus)="agendaNameFieldTouched=true"  (focusout)="agendaNameFieldTouched=false" 
                                 [formControl]="agendaAddForm.controls['agendaType']" autocomplete="off">
                            </div>
                        </div> -->



                        <div class="col-md-6" *ngIf="meetingBoolean && isCategoryNoBoolean">

                        </div>
                        <div class="col-md-2" *ngIf="meetingBoolean && isCategoryNoBoolean ">
                            <label class="col-form-label" for="l0">Select Meeting

                            </label>
                        </div>
                        <div class="col-md-4" *ngIf="meetingBoolean && isCategoryNoBoolean">
                            <div class="form-group">
                                <select class="form-control" [formControl]="agendaAddForm.controls['meeting']">
                                    <option value=null [selected]="true">Select</option>
                                    <option *ngFor="let meeting of meetingDateOnSelectedType" [value]="meeting._id">
                                        {{meeting.meetingList.MeetingDate | date: "dd-MM-y"}}
                                        {{meeting.meetingList.MeetingTime}}
                                    </option>
                                </select>

                                <div *ngIf="booleanMeetingValidate" class="form-control-error-custom">Meeting is
                                    required
                                </div>
                                <div *ngIf="isChangeToMeeting=='Yes'" class="warning-note badge badge-warning">
                                    Note: This Agenda can not be assigned to another meeting as it is already assigned
                                    to a meeting.
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">

                                <div class="col-md-2">
                                    <label class="col-form-label" for="l5">Preamble & Resolution
                                    </label>
                                </div>
                                <div class="col-md-6" *ngIf="imageAdd">
                                    <div class="form-group">
                                        <!-- <input type="text" class='form-control' readonly='true' value="File Not Available"> -->
                                        <input type="file" class='form-control' (change)="fileChangeEvent($event)"
                                            [disabled]="!hasPermission" accept=".docx, .pdf" />
                                        <span *ngIf="typeHasError" style="color: red">
                                            Please upload valid file format.
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="imageAddRev">
                                    <button type="button" class="btn-sm btn btn-default" (click)="revert()">
                                        <span class="fa fa-refresh"></span>
                                    </button>
                                </div>

                                <div class="col-md-6" *ngIf="imageEdit">
                                    <div class="form-group" *ngIf="TotalFile.length==1">
                                        <input type="text" [formControl]="agendaAddForm.controls['image']"
                                            class='form-control' readonly='true'>
                                    </div>

                                    <div *ngIf="TotalFile.length > 1" id="div-downloaded-file-list" class="form-group"
                                        style="width: 100%; max-height: 100px; overflow-y: auto;border:solid #e4e9f0 1px;padding: 7px 10px;">

                                        <div *ngFor="let document of  TotalFile;let count=index">
                                            <a href="{{downloadLink}}{{agendaId}}/{{token}}?position={{document.srno}}"
                                                style="margin: 0px 5px;">
                                                <span
                                                    class="fa fa-download">&nbsp;&nbsp;{{document.actualFileName}}</span>
                                            </a>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="imageEdit">
                                    <button *ngIf="imageEdit && TotalFile.length==1" type="button"
                                        class="btn-sm btn btn-warning" (click)="downloadDoc()">
                                        <span class="fa fa-download"></span>
                                    </button>
                                    <!-- <button *ngIf="imageEdit && TotalFile.length > 1" type="button" class="btn-sm btn btn-warning" (click)="downloadAll()">
                                        <span class="fa fa-file-archive-o"></span>
                                    </button> -->
                                    <!-- <button type="button" class="btn-sm btn btn-danger" (click)="removeDoc()">
                                        <i class="fa fa-pencil"></i>Replace files
                                    </button> -->

                                    <button type="button" class="btn-sm btn btn-primary" (click)="addNewDoc()">
                                        <i class="fa fa-plus"></i>&nbsp;Add New files
                                    </button>




                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-2"></div>
                                <div class="col-md-6">
                                    <span class="warning-note badge badge-warning">
                                        Note: PDF format file cannot be uploaded from this screen. Please click on "Save" or "Update" & then upload it from the Agenda List screen.
                                    </span>
                                </div>
                                <div class="col-md-4"></div>
                            </div>
                        </div>  -->
                        <div class="col-md-12"></div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-2">
                                    <label class="col-form-label" for="l0">Agenda Type</label>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <!-- <select class="form-control" [formControl]="agendaAddForm.controls['agendaType']" >
                                            <option [selected]="true" value=null>Select</option>
                                            <option *ngFor="let option of agendaTypeOption" [value]="option._id">
                                                {{option.name}}</option>
                                        </select> -->
                                        <datalist id="agendatypedata" *ngIf="agendaNameFieldTouched">
                                            <option *ngFor="let option of agendaTypeOption">{{option}}</option>
                                        </datalist>
                                        <input type="text" (keypress)="getAgendaType()" list="agendatypedata" size="10"
                                            class="form-control" (focus)="agendaNameFieldTouched=true"
                                            (focusout)="agendaNameFieldTouched=false"
                                            [formControl]="agendaAddForm.controls['agendaType']" autocomplete="off">
                                    </div>
                                </div>

                                <div class="col-md-2">
                                    <label class="col-form-label" for="l5">Minute Document
                                    </label>
                                </div>
                                <div class="col-md-4" *ngIf="minuteDocAdd">
                                    <div class="form-group">

                                        <input type="file" class='form-control'
                                            (change)="fileChangeEventMinuteDocument($event)" [disabled]="!hasPermission"
                                            accept=".docx" />
                                        <span *ngIf="typeHasError1" style="color: red">
                                            Please upload valid file format.
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="minuteDocAddRev">
                                    <button type="button" class="btn-sm btn btn-default" (click)="revertDocMin()">
                                        <span class="fa fa-refresh"></span>
                                    </button>
                                </div>

                                <div class="col-md-6" *ngIf="minuteDocEdit">
                                    <div class="form-group" *ngIf="TotalFileMinDoc.length==1">
                                        <input type="text" [formControl]="agendaAddForm.controls['imageMinDoc']"
                                            class='form-control' readonly='true'>
                                    </div>

                                    <div *ngIf="TotalFileMinDoc.length > 1" id="div-downloaded-file-list"
                                        class="form-group"
                                        style="width: 100%; max-height: 100px; overflow-y: auto;border:solid #e4e9f0 1px;padding: 7px 10px;">

                                        <div *ngFor="let document of  TotalFileMinDoc;let count=index">
                                            <a href="{{downloadLink}}{{agendaId}}?position={{document.srno}}"
                                                style="margin: 0px 5px;">
                                                <span
                                                    class="fa fa-download">&nbsp;&nbsp;{{document.actualFileName}}</span>
                                            </a>
                                            <hr />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" *ngIf="minuteDocEdit">


                                    <button *ngIf="minuteDocEdit && TotalFileMinDoc.length==1" type="button"
                                        class="btn-sm btn btn-warning" (click)="downloadMinDoc()">
                                        <span class="fa fa-download"></span>
                                    </button>


                                    <button type="button" class="btn-sm btn btn-primary" (click)="addNewMinDoc()">
                                        <i class="fa fa-plus"></i>&nbsp;Add New files
                                    </button>




                                </div>
                            </div>
                        </div>


                        <div class="col-md-12">
                            <section class="panel panel-default">
                                <div class="panel-heading">
                                    <h5 class="panel-title pull-left">Compliances</h5>
                                    <div style="float: right;">
                                        <button type="button" class="btn-sm btn btn-primary"
                                            data-target="#AddCompliancesDialog" (click)="showAddComplaincePopup()"
                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                            <i class="fa fa-plus"></i>&nbsp;Add Compliances
                                        </button>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="panel-body" style="padding: 12px 13px 38px;">
                                    <div class="col-md-12" style="padding: 0">
                                        <table datatable [dtOptions]="dtOptionsForAddedTask"
                                            [dtTrigger]="dtTriggerForAddedTask"
                                            class="table table-hover compact cell-border nowrap stripe"
                                            id="addedtaskTable" style="cursor: pointer;">
                                            <thead>
                                                <tr style="color: #1e458b;">
                                                    <th>Task Name </th>
                                                    <th>Task Description </th>
                                                    <th>Global/Company Specific </th>
                                                    <th>Tag </th>
                                                    <th>
                                                        <span
                                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">Remove</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let companytask of agendaAddedTaskList; let count=index">
                                                    <td tabindex="1">{{companytask.TaskName }}</td>
                                                    <td tabindex="2">{{companytask.TaskDescription }}</td>
                                                    <td tabindex="3">
                                                        <span *ngIf="companytask.IsGlobal">Global</span>
                                                        <span *ngIf="!companytask.IsGlobal">Company Specific</span>
                                                    </td>
                                                    <td tabindex="4">{{companytask.GroupName }}</td>
                                                    <td tabindex="4">
                                                        <button type="button" class="btn-sm btn btn-danger"
                                                            (click)="removeTaskFromAgendaList(companytask.Task_id,companytask.IsGlobal)"
                                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                                            <span class="fa fa-close"></span>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>
                        </div>


                        <div class="col-md-12">
                            <section class="panel panel-default">
                                <div class="panel-heading">
                                    <h5 class="panel-title pull-left">Process</h5>
                                    <div style="float: right;">
                                        <button type="button" class="btn-sm btn btn-primary"
                                            data-target="#AddProcessDialog" (click)="onPopupAddProcessEvent()"
                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                            <i class="fa fa-plus"></i>&nbsp;Add Process
                                        </button>
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                                <div class="panel-body" style="padding: 12px 13px 38px;">
                                    <div class="col-md-12" style="padding: 0;width: -webkit-fill-available !important;">
                                        <table datatable [dtOptions]="dtOptionsForAddedProcess"
                                            [dtTrigger]="dtTriggerForAddedProcess"
                                            class="table table-hover compact cell-border nowrap stripe"
                                            id="processTable"
                                            style="cursor: pointer; width: -webkit-fill-available !important;">
                                            <thead>
                                                <tr style="color: #1e458b;">
                                                    <th>Process Name </th>
                                                    <th class="process-list-column">Global/Company Specific </th>
                                                    <th class="process-list-column">Meeting Type </th>
                                                    <th class="process-list-action">
                                                        <span
                                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">Remove</span>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr  *ngFor="let process of addedProcess; let count=index" >
                                                    <td tabindex="1">{{process.ProcessName }}</td>
                                                    <td class="process-list-column">
                                                        <span *ngIf="process.IsGlobal">Global</span>
                                                        <span *ngIf="!process.IsGlobal">Company Specific</span>
                                                    </td>
                                                    <td class="process-list-column">
                                                        <!-- <span *ngIf="process.IsMeetingTask && process.MeetingTypeId!=null">{{process.ProcessDataList[0].MeetingType}}</span> -->
                                                        <span
                                                            *ngIf="process.ProcessDataList.length > 0">{{process.ProcessDataList[0].MeetingType}}</span>
                                                        <span *ngIf="process.MeetingTypeId==null">N/A</span>
                                                    </td>
                                                    <td class="process-list-action">

                                                        <button type="button" class="btn-sm btn btn-danger"
                                                            (click)="removeProcess(process._id,process.IsGlobal);"
                                                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                                                            <span class="fa fa-close"></span>
                                                        </button>
                                                        <!-- {{process._id}} -->
                                                    </td>
                                                </tr>
                                                <tr *ngIf="addedProcess.length === 0">
                                                    <td colspan="4" class="text-center">No data available in table</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                    <!-- Row Close -->
                    <div class="form-actions" style="text-align: right">

                        <button type="button" class="btn-sm btn btn-primary" (click)='addAgenda();'
                            [disabled]="!agendaAddForm.valid || typeHasError || typeHasError1 || agendaDisabledOnclick"
                            id="saveBtnAgenda"
                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                            <i class="fa fa-save"></i>&nbsp;Save</button>
                        <button type="button" class="btn-sm btn btn-primary" (click)='updateAgenda()'
                            [disabled]="!agendaAddForm.valid || typeHasError || typeHasError1 || agendaDisabledOnclick"
                            id="editBtnAgenda"
                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                            <i class="fa fa-save"></i>&nbsp;Update</button>
                        <button type="button" class="btn-sm btn btn-default" data-toggle="modal"
                            data-target="#clearDataModal"
                            [appHasPermission]="{'Url': '/agenda/edit?goveva=true&email=', 'method':'put', 'menu': 'Agenda'}">
                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>

                        <!-- <button type="button" class="btn btn-sm">Cancel</button> -->
                    </div>
                    <!-- End Column Sizing -->
                </form>
            </div>
        </div>
    </div>


    <div class="modal fade" id="clearDataModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                        <i class="fa fa-question-circle-o mr-2"></i>Confirm
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            Are you sure you want to clear Agenda details?
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="back()" data-dismiss="modal">
                        <i class="fa fa-check"></i>&nbsp;Yes</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;No</button>
                </div>
            </div>
        </div>
    </div>


    <!-- Add Category Modal -->
    <div class="modal fade modal-size-medium" id="categoryDialog" tabindex="-1" role="dialog" data-backdrop="static"
        data-keyboard="false" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form [formGroup]="categoryMasterForm" class="well">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModalLabel">Category Master</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-control-label">Category Type</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">

                                    <div class="md-radio">

                                        <input type="radio" id="ISglobal"
                                            [formControl]="categoryMasterForm.controls['IsGlobal']"
                                            (click)="getMeetingTypeList('Global')" style="position:absolute"
                                            name="IsGlobal" value="Global" class="form-check-input radio">
                                        <label for="ISglobal" class="form-check-label">Global</label>
                                        <input type="radio" id="Company"
                                            [formControl]="categoryMasterForm.controls['IsGlobal']"
                                            (click)="getMeetingTypeList('Company')" style="position:absolute"
                                            name="IsGlobal" value="Company" class="form-check-inpu radio"
                                            checked="checked">
                                        <label for="Company" class="form-check-label">Company</label>

                                    </div>



                                    <!-- <label class="form-check-label">
                                           Global</label>
                                        <label class="form-check-label">
                                            Company</label> -->
                                </div>
                                <div *ngIf="categoryMasterForm.controls['IsGlobal'].hasError('required') && categoryMasterForm.controls['IsGlobal'].touched"
                                    class="form-control-error-custom">
                                    Category Type is required
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="form-control-label">Default</label>
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <div class="md-radio md-radio-inline">
                                        <input id="isDefaultYes" type="radio"
                                            [formControl]="categoryMasterForm.controls['isDefault']"
                                            style="position:absolute" name="isDefault" value=true
                                            class="form-check-input">
                                        <label for="isDefaultYes">Yes</label>
                                    </div>
                                    <div class="md-radio md-radio-inline">
                                        <input id="isDefaultNo" type="radio"
                                            [formControl]="categoryMasterForm.controls['isDefault']"
                                            style="position:absolute" name="isDefault" value=false
                                            class="form-check-input">
                                        <label for="isDefaultNo">No</label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label class="form-control-label" for="l0">Category Name
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                </label>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <input [formControl]="categoryMasterForm.controls['CategoryName']"
                                        class="form-control" required="required">
                                    <div *ngIf="categoryMasterForm.controls['CategoryName'].hasError('required') && categoryMasterForm.controls['CategoryName'].touched"
                                        class="form-control-error-custom">
                                        Category Name is required
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-control-label" for="l0">Meeting Type
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                </label>
                            </div>
                            <div class="col-md-9">
                                <div class="form-group">
                                    <select [formControl]="categoryMasterForm.controls['MeetingType']"
                                        required="required" class="form-control select">
                                        <option value="" [selected]="true">Select</option>
                                        <option *ngFor="let meetingType of meetingTypes" value={{meetingType._id}}>
                                            {{meetingType.MeetingType}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="btnsaveCategory" type="button" class="btn-sm btn btn-primary"
                            [disabled]="!categoryMasterForm.valid || categoryDisabledOnclick" (click)="addCategory()">
                            <i class="fa fa-save"></i>&nbsp;Save</button>
                        <!-- <button id="btnupdateCategory" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]="!categoryMasterForm.valid"
          (click)="editCategory()">Update</button> -->
                        <button type="button" class="btn btn-sm" data-dismiss="modal">
                            <i class="fa fa-times"></i>&nbsp;Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    </div>






    <div id="indexGrouping" class="modal fade" role="dialog">
        <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add New</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="form-control-label">Grouping Type</label>
                            <span _ngcontent-c2="" style="color: red;">*</span>
                        </div>
                        <div class="col-md-9">

                            <div class="form-group">
                                <div class="md-radio md-radio-inline">
                                    <input id="GlobalGroup" type="radio" [(ngModel)]="GroupingIndex" name="GlobalGroup"
                                        style="padding:6px;" value="GlobalGroup"
                                        (click)="setGroupingType('GlobalGroup')">
                                    <label for="GlobalGroup">Global</label>
                                </div>
                                <div class="md-radio md-radio-inline">
                                    <input id="CompanyGroup" type="radio" [(ngModel)]="GroupingIndex" name="GlobalGroup"
                                        style="padding:6px;" value="CompanyGroup"
                                        (click)="setGroupingType('CompanyGroup')">
                                    <label for="CompanyGroup">Company</label>
                                </div>

                                <!-- <div class="form-control-error-custom" *ngIf="!GroupingIndex">
                                  Grouping Type is required
                              </div> -->
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-control-label" for="l0">Grouping Number
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                        </div>
                        <div class="col-md-9">
                            <div class="form-group">
                                <input [(ngModel)]='GroupingNumber' class="form-control" required="required"
                                    (keydown)="noBlankSpaceAtStart($event)" (click)="groupingNumberFieldTouched()">
                                <div class="form-control-error-custom"
                                    *ngIf="!GroupingNumber && GroupingNumberTouched == true">
                                    Grouping Number is required
                                </div>
                            </div>

                        </div>
                        <div class="col-md-3">
                            <label class="form-control-label" for="l0">Grouping Name
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                        </div>
                        <div class="col-md-9">
                            <div class="form-group">
                                <input [(ngModel)]='GroupingName' class="form-control" required="required"
                                    (keydown)="noBlankSpaceAtStart($event)" (click)="groupingNameFieldTouched()">
                                <div class="form-control-error-custom"
                                    *ngIf="!GroupingName && GroupingNameTouched == true">
                                    Grouping Name is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"
                        [disabled]='!GroupingIndex || !GroupingName || !GroupingNumber || disabledOnclick'
                        (click)="SaveIndexGrouping()" data-dismiss="modal">Save</button>
                    <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>

        </div>
    </div>

    <!-- city modal -->
    <!-- <div id="agendaTypeAddBtn" class="modal fade" role="dialog">
        <div class="modal-dialog">

            Modal content
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add New</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                </div>
                <div class="modal-body">
                    <div class="row">
                        
                        <div class="col-md-3">
                            <label class="form-control-label" for="l0">Agenda Type
                                <span _ngcontent-c2="" style="color: red;">*</span>
                            </label>
                        </div>
                        <div class="col-md-9">
                            <div class="form-group">
                                <input [(ngModel)]='agendaName' class="form-control" required="required"
                                (click)="agendaNameFieldTouched=true;">
                                <div class="form-control-error-custom" *ngIf="!agendaName && agendaNameFieldTouched == true">
                                    Agenda Type is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary" 
                    (click)="SaveCity()" data-dismiss="modal">Save</button>
                    <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
                </div>
            </div>

        </div>
    </div> -->



    <div class="modal fade modal-size-large" id="AddCompliancesDialog" tabindex="-1" role="dialog" data-keyboard="false"
        data-backdrop="static" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="taskLabel">
                        <i class="fa fa-plus"></i>&nbsp;Add Compliances
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body modal-body-agendaCompliances">

                    <section class="card search-box">
                        <div class="card-block">

                            <div class="row">
                                <div class="col-md-3">
                                    <label>User defined / Predefined</label>
                                </div>


                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label> Tag</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label> Event Based / Periodic</label>
                                </div>



                                <div class="col-md-3">

                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-3">
                                    <div class="input-group">
                                        <!-- <label>Search By UserDefined/Predefined</label> -->
                                        <div class="md-radio md-radio-inline">
                                            <input id="IsPredefinedYes" type="radio" style="position:absolute"
                                                name="TaskuserdefinedorPredefined"
                                                [(ngModel)]="SearchtaskUserdefinedorPredefinedModel" value='true'
                                                class="form-check-input">
                                            <label for="IsPredefinedYes">Pre-Defined</label>
                                        </div>
                                        <div class="md-radio md-radio-inline">
                                            <input id="IsPredefinedNo" type="radio" style="position:absolute"
                                                name=" TaskuserdefinedorPredefined"
                                                [(ngModel)]="SearchtaskUserdefinedorPredefinedModel" value='false'
                                                class="form-check-input">
                                            <label for="IsPredefinedNo">User Defined</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <select id="groupdropdown" class="form-control select"
                                            (change)="getSelectedGroupID($event)">
                                            <option value="null">Select</option>
                                            <option *ngFor="let group of groupTypes" value={{group._id}}>
                                                {{group.GroupName}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <!-- <label> Search By EventBased/Periodic</label> -->
                                    <div class="md-radio md-radio-inline">
                                        <input id="IsEventBased" type="radio" style="position:absolute"
                                            name="TaskEventbasedorPeriodic"
                                            [(ngModel)]="SearchtaskEventbasedorPeriodicModel" value='1'
                                            class="form-check-input" [disabled]=true>
                                        <label for="IsEventBased">Event Based</label>
                                    </div>
                                    <div class="md-radio md-radio-inline">
                                        <input id="IsPeriodic" type="radio" style="position:absolute"
                                            name=" TaskEventbasedorPeriodic"
                                            [(ngModel)]="SearchtaskEventbasedorPeriodicModel" value='2'
                                            class="form-check-input" [disabled]=true>
                                        <label for="IsPeriodic">Periodic</label>
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class=" text-right">

                                        <button id="btnSearch" class="btn btn-primary btn-sm center-block"
                                            (click)="showTasksBySearchData()" Style="width: 100px;">
                                            <i class="fa fa-search"></i>&nbsp;Search</button>&nbsp;&nbsp;
                                        <button id="btnClear" class="btn btn-default btn-sm center-block"
                                            (click)="refreshTaskList()" Style="width: 100px;">
                                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="margin-bottom-50">
                                <div class="table-responsive">

                                    <table datatable [dtOptions]="dtOptionsTaskAddingPopup"
                                        [dtTrigger]="dtTriggerTaskAddingPopup"
                                        class="table table-hover compact cell-border nowrap stripe"
                                        id="companytaskTable" style="cursor: pointer; width: max-content">
                                        <!-- style="width:3500px" -->
                                        <thead>
                                            <tr>
                                                <th tabindex="1" style="display: none">Task Name </th>
                                                <th tabindex="1">
                                                    <div class="md-checkbox">
                                                        <input id="selectcheckboxall" class="md-checkbox"
                                                            type="checkbox" [(ngModel)]="selectedAll"
                                                            (change)="checkAllIfselectAll();" />
                                                        <label for="selectcheckboxall">&nbsp;</label>
                                                    </div>
                                                </th>
                                                <th tabindex="1">Task Name </th>
                                                <th tabindex="1">Task Description </th>
                                                <th tabindex="1">Global/Company Specific </th>
                                                <th tabindex="1">Tag</th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let companytask of companytasklist; let count=index">
                                                <td tabindex="1" style="display: none">{{companytask.ID}}</td>
                                                <td>
                                                    <div class="md-checkbox">
                                                        <input id="selectcheckbox{{count +1 }}" type="checkbox"
                                                            [(ngModel)]="companytask.SelectedTasks"
                                                            (change)="checkselected($event);">
                                                        <label for="selectcheckbox{{count +1 }}">&nbsp;</label>
                                                    </div>
                                                </td>
                                                <!-- <td>{{count+1}}</td> -->
                                                <td tabindex="1">{{companytask.TaskName }}</td>
                                                <td tabindex="2">{{companytask.TaskDescription }}</td>
                                                <td tabindex="3">
                                                    <span *ngIf="companytask.IsGlobal">Global</span>
                                                    <span *ngIf="!companytask.IsGlobal">Company Specific</span>
                                                </td>
                                                <td tabindex="4">{{companytask.GroupName }}</td>

                                            </tr>
                                        </tbody>

                                    </table>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button id="btnsaveTask" type="button" class="btn-sm btn btn-primary"
                        (click)="addCompliancesTaskToAgendaForm()">
                        <i class="fa fa-check"></i>&nbsp;Add Selected Task</button>
                    <!-- <button id="btnupdateCategory" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]="!categoryMasterForm.valid"
              (click)="editCategory()">Update</button> -->
                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Cancel</button>
                </div>
            </div>

        </div>
    </div>



    <div class="modal fade modal-size-large" id="AddProcessDialog" tabindex="-1" role="dialog" data-keyboard="false"
        data-backdrop="static" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="taskLabel">
                        <i class="fa fa-plus"></i>&nbsp;Add Process
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body modal-body-agendaCompliances">
                    <section class="card search-box" *ngIf="!processError.hasError">
                        <div class="card-block">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="margin-bottom-50">

                                        <div class="modal-body">

                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <div class="md-radio md-radio-inline">
                                                            <input id="IsPreDefined" type="radio"
                                                                style="position:absolute"
                                                                name="IsPredefinedorUserdefined"
                                                                [(ngModel)]="SearchprocessUserdefinedorPredefinedModel"
                                                                [ngModelOptions]="{standalone: true}" value="Predefined"
                                                                (click)="CheckProcessType('Predefined')"
                                                                class="form-check-input">
                                                            <label for="IsPreDefined">Pre defined</label>
                                                        </div>
                                                        <div class="md-radio md-radio-inline">
                                                            <input id="IsUserDefined" type="radio"
                                                                style="position:absolute"
                                                                name="IsPredefinedorUserdefined"
                                                                [(ngModel)]="SearchprocessUserdefinedorPredefinedModel"
                                                                [ngModelOptions]="{standalone: true}"
                                                                value="Userdefined"
                                                                (click)="CheckProcessType('Userdefined')"
                                                                class="form-check-input">
                                                            <label for="IsUserDefined">User defined</label>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div class="col-md-2">
                                                    <div class="input-group">

                                                        <button type="button" class="btn btn-sm btn-default"
                                                            (click)="showAllProcesses()" title="refresh">
                                                            <i class="fa fa-refresh"></i>&nbsp;Clear
                                                        </button>
                                                    </div>
                                                </div>



                                                <div class="col-md-2">
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="margin-bottom-50">
                                <div class="table-responsive">
                                    <div *ngIf="processError.hasError" class="popupProcessHasError">
                                        {{ processError.message}}
                                    </div>


                                    <table datatable id="processTablePopup" [dtOptions]="dtOptionsProcessAddingPopup"
                                        [dtTrigger]="dtTriggerProcessAddingPopup"
                                        class="table table-hover compact cell-border nowrap stripe"
                                        style="cursor: pointer;">
                                        <thead>
                                            <tr>
                                                <th style="display: none">Process ID </th>
                                                <th class="process-list-action">

                                                    <div class="md-checkbox">
                                                        <!-- <input id="selectProcesscheckboxall" class="md-checkbox" type="checkbox" (change)="selectAllProcess($event);"/> -->
                                                        <input id="selectProcesscheckboxall" class="md-checkbox"
                                                            type="checkbox" [(ngModel)]="selectedAllProcesses"
                                                            (change)="selectAllProcess($event);" />
                                                        <label for="selectProcesscheckboxall">&nbsp;</label>
                                                    </div>
                                                </th>
                                                <th>Process Name </th>
                                                <th class="process-list-column">Global/Company Specific </th>
                                                <th class="process-list-column">Meeting Type </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let process of processes; let count=index">
                                                <td tabindex="1" style="display: none"> {{process._id }}</td>
                                                <td class="process-list-action">
                                                    <div class="md-checkbox">
                                                        <!-- <input  id="selectProcesscheckbox{{count +1 }}" type="checkbox" [(ngModel)]="process.IsSelected" (change)="checkProcessselected($event);"> -->
                                                        <input id="selectcheckboxOpen{{count +1 }}" type="checkbox"
                                                            [(ngModel)]="process.IsSelected"
                                                            (change)="checkProcessselected($event);">
                                                        <label for="selectcheckboxOpen{{count +1 }}">&nbsp;</label>
                                                    </div>
                                                </td>
                                                <td tabindex="1">{{process.ProcessName }}</td>
                                                <td class="process-list-column">
                                                    <span *ngIf="process.IsGlobal">Global</span>
                                                    <span *ngIf="!process.IsGlobal">Company Specific</span>
                                                </td>
                                                <td class="process-list-column">
                                                    <!-- <span *ngIf="process.IsMeetingTask && process.MeetingTypeId!=null">{{process.ProcessDataList[0].MeetingType}}</span> -->
                                                    <span
                                                        *ngIf="process.ProcessDataList.length > 0">{{process.ProcessDataList[0].MeetingType}}</span>
                                                    <span *ngIf="process.MeetingTypeId==null">N/A</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button *ngIf="!processError.hasError" id="btnsaveProcess" type="button"
                        class="btn-sm btn btn-primary" (click)="addProcessToAgendaForm()"
                        [disabled]="!markProcessSelected">
                        <i class="fa fa-check"></i>&nbsp;Add Selected Process</button>
                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Cancel</button>
                </div>
            </div>

        </div>
    </div>

    <div class="modal fade" id="warningModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Warning
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12" id="addWarningText">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Close</button>
                </div>
            </div>
        </div>
    </div>


</section>
<app-alert></app-alert>
<!-- END: forms/basic-forms-elements -->